import React from 'react';
import { FaEnvelope, FaLinkedin } from 'react-icons/fa';
import { site } from '../../configs/site';

// Shared blue footer -- previously only lived inline in Home.jsx. Pulled out
// into its own component so use-case pages (see UseCaseView.jsx) can show
// the exact same footer instead of the page just ending after its content,
// which is how every use-case page looked before this.
const SiteFooter = () => {
  return (
    <div className="mt-auto w-full bg-primary-600">
      <div className="flex flex-col items-center gap-6 px-4 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-4 lg:px-10">
        {/* <div className="flex h-24 shrink-0 items-center gap-4 rounded-md bg-white px-4"> */}
          {/* Links out to the main West Loop Strategy site (new tab). */}
          <a
            href="https://www.westloop.io"
            target="_blank"
            rel="noopener noreferrer"
            className="flex shrink-0 items-center rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
          >
            <img
              src="/logos/ai-services-competency.png"
              alt="AWS Partner - AI Services Competency"
              className="h-14 w-auto shrink-0"
            />
          </a>
        {/* </div> */}

        <div className="max-w-5xl text-center text-sm text-white/80">
          <p>
            West Loop Strategy is a Chicago-based AWS consulting firm helping organizations build and modernize SaaS, data, and AI solutions. Founded in 2019, we are an Advanced Tier AWS Consulting Partner with 17 Service Delivery Partnerships, GenAI and Data & Analytics Competencies, and a Strategic Collaboration Agreement with AWS.
          </p>
          <p className="mt-3">
            Our team supports clients from startups to Fortune 500 companies and government agencies.
          </p>
        </div>

        {/* West Loop logo (links to the main site) with email + LinkedIn
            buttons stacked beside it. */}
        <div className="flex shrink-0 items-center gap-4">
          <a
            href="https://www.westloop.io"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-sm hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            <img
              src="/logos/Vertical_Mono_White.png"
              alt="West Loop Strategy website"
              className="h-20 w-auto"
            />
          </a>
          <div className="flex flex-col gap-2">
            <a
              href={`mailto:${site.contact.email}`}
              title={site.contact.email}
              className="inline-flex items-center justify-center gap-2 rounded-md border border-white/60 px-3 py-1.5 text-sm font-semibold text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              <FaEnvelope className="h-4 w-4" aria-hidden="true" />
              Email us
            </a>
            {site.contact.linkedin && (
              <a
                href={site.contact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="West Loop Strategy on LinkedIn"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-white/60 px-3 py-1.5 text-sm font-semibold text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
              >
                <FaLinkedin className="h-4 w-4" aria-hidden="true" />
                LinkedIn
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteFooter;
